import React, { useState, useEffect, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { AppContext } from '@/AppContext';
import SAInnerMenu from '@/components/SAInnerMenu/SAInnerMenu';
import TariffCard from './components/TariffCard/TariffCard';

const PREFIX = 'TariffList';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(3),
  },
}));

const TariffList = props => {
  const appContext = useContext(AppContext);

  const [tariffs, setTariffs] = useState(undefined);
  useEffect(() => {
    appContext.configApi
      .getServicePlanConfig()
      .then(({ data }) => {
        setTariffs(data);
      })
      .catch(appContext.errorHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!tariffs) {
    return null;
  }

  return (
    <Root className={classes.root}>
      <SAInnerMenu />
      {tariffs.servicePlans.map(sp => (
        <TariffCard tariff={sp} />
      ))}
    </Root>
  );
};

export default TariffList;
